import { BaseEntity } from "./base-entity";
import moment from "moment";

export class MatterWorkItem extends BaseEntity {
  name: string;
  status: string;
  dueDate: string;
  inviteGuid: string;

  isCompleted(): boolean {
    return this.status === "COMPLETED";
  }

  isOverdue(): boolean {
    let today = moment().format("YYYY/MM/DD");
    return this.dueDate && moment(today).isAfter(this.dueDate);
  }

  get dueDateNumber(): number {
    if (this.dueDate) {
      return new Date(this.dueDate).getTime();
    } else {
      return 0;
    }
  }
}
